import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initSentry } from './lib/sentry';
import './styles/tailwind.css';

initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('root element não encontrado');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
